<router-outlet></router-outlet>
<a class="bug-report" target="_blank" href="https://app.pipefy.com/public/form/oHHWSV-4">
  <i class="icon icon-bug-solid"></i>
</a>
